import { i18n } from '../../i18n/translate';
import { ConfirmationModal } from '../ConfirmationModal';
import PropTypes from 'prop-types';
import React from 'react';

export const CancelConfirmModal = props => {
  const {
    body = i18n.t('Are you sure you want to discard all your changes?'),
    branded = false,
    cancelButtonText = i18n.t('No'),
    confirmButtonText = i18n.t('Yes'),
    container,
    onCancelClose = () => {},
    title = i18n.t('Discard unsaved changes'),
  } = props;

  return (
    <ConfirmationModal
      branded={branded}
      cancelButtonText={cancelButtonText}
      canClickOff={true}
      confirmButtonText={confirmButtonText}
      container={container}
      onCancel={() => onCancelClose(false)}
      onConfirm={() => onCancelClose(true)}
      show={props.show}
      title={title}
    >
      <div>{body}</div>
    </ConfirmationModal>
  );
};

CancelConfirmModal.propTypes = {
  body: PropTypes.string,
  branded: PropTypes.bool,
  cancelButtonText: PropTypes.string,
  confirmButtonText: PropTypes.string,
  container: PropTypes.node,
  onCancelClose: PropTypes.func.isRequired,
  show: PropTypes.bool,
  title: PropTypes.string,
};
